import type { ReactElement } from "react";
import { useMemo, useState } from "react";

import { translate } from "app/filters/i18nFilter";
import type { IRadioSelectItem } from "app/pages/sales-intelligence/common-components/form-fields";
import { FormFieldLabel } from "app/pages/sales-intelligence/common-components/form-fields";
import { KeywordsTrafficSource } from "app/pages/sales-intelligence/domain/leads/types/enums";
import type { IFilterViewBaseProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";
import {
    FilterContentContainer,
    StyledRadioSelect,
} from "app/pages/sales-intelligence/modules/leads-search-filters/components/filters/styles";
import type FindKeywordsFilter from "app/pages/sales-intelligence/modules/leads-search-filters/models/KeywordsFilter/KeywordsFilter";
import { AutocompleteKeywords } from "pro-features/components/AutocompleteKeywords/AutocompleteKeywords";

import { TRANSLATION_PREFIX } from "./const";

const KeywordsFilter = ({
    filter: { options },
    value,
    onFilterUpdate,
}: IFilterViewBaseProps<FindKeywordsFilter>): ReactElement | null => {
    const [trafficSource, setTrafficSource] = useState<KeywordsTrafficSource>(
        value?.trafficSource ?? KeywordsTrafficSource.Organic,
    );

    const handleTrafficSourceSelect = (val: KeywordsTrafficSource) => {
        setTrafficSource(val);
        if (value?.keyword) {
            onFilterUpdate({ ...value, trafficSource: val });
        }
    };

    const handleKeywordSelect = (keyword: string) => {
        onFilterUpdate({ keyword, trafficSource });
    };

    const radioItems = useMemo(
        (): IRadioSelectItem[] =>
            options.map((val) => ({
                id: val,
                text: translate(`${TRANSLATION_PREFIX}.trafficSource.${val}`),
            })),
        [options],
    );

    return (
        <FilterContentContainer>
            <StyledRadioSelect
                size="sm"
                selected={trafficSource}
                onSelect={handleTrafficSourceSelect}
                items={radioItems}
            />
            <FormFieldLabel text={translate(`${TRANSLATION_PREFIX}.fieldLabel`)}>
                <AutocompleteKeywords
                    autocompleteProps={{
                        placeholder: translate(`${TRANSLATION_PREFIX}.dropdownPlaceholder`),
                    }}
                    emptyState={{ hideEmptyState: true }}
                    selectedValue=""
                    onClick={handleKeywordSelect}
                />
            </FormFieldLabel>
        </FilterContentContainer>
    );
};

export default KeywordsFilter;
